module.exports = __webpack_public_path__ + "img/logo_bp_s.52e43ad0.png";